<script>
    import {onMount} from "svelte";
    import {eventBridge} from "../../stores.js";

    const maxFrequency = Math.floor(0.95 * 2 * 60 * 1000); // heartbeat at least every x millis; must be less than keycloak "login timeout"
    const halfMaxFrequency = Math.floor(maxFrequency / 2);
    const frequencyOffset = Math.floor(Math.random() * halfMaxFrequency); // half of the maxFrequency as random offset
    const frequency = Math.floor(halfMaxFrequency + frequencyOffset); // constant half of maxFrequency plus the random offset


    let lastHeartbeat = currentTime();
    let lastUserInteraction = currentTime();

    function currentTime() {
        return new Date().getTime();
    }

    function handleUserInteraction() {
        lastUserInteraction = currentTime();
    }


    function heartbeat() {
        // console.log("heart..");

        if (lastUserInteraction > lastHeartbeat) {
            // console.log("..beat");
            $eventBridge.dispatchEvent('kc:heartbeat');
        }

        lastHeartbeat = currentTime();
    }

    onMount(() => {
        // setInterval(() => {
        //     console.log("1 min");
        // }, 60 * 1000);

        // console.log('Heartbeat frequency: ', frequency);
        setInterval(heartbeat, frequency);

        document.addEventListener('click', handleUserInteraction);
        document.addEventListener('keydown', handleUserInteraction);

        return () => {
            document.removeEventListener('click', handleUserInteraction);
            document.removeEventListener('keydown', handleUserInteraction);
        };
    });
</script>